import React from 'react';
import { RSVPLabel } from '../RSVP/RSVP';

export type Props = {
    hasCroppedLogo: boolean;
    shouldDisplayRsvp: boolean;
    displayPrice: string;
    shouldShowExternalTicketingProvider: boolean;
    externalTicketingProviderLabelText: string;
};

export const Footer = ({
    hasCroppedLogo,
    shouldDisplayRsvp,
    displayPrice,
    shouldShowExternalTicketingProvider,
    externalTicketingProviderLabelText,
}: Props) => {
    return (
        <div
            className={`listing-hero-footer hide-small hide-medium ${
                hasCroppedLogo ? '' : 'l-pad-left-4'
            }`}
        >
            {shouldDisplayRsvp ? (
                <div id="listings-root__rsvp-label">
                    <RSVPLabel />
                </div>
            ) : (
                <>
                    <div>{displayPrice}</div>
                    {shouldShowExternalTicketingProvider && (
                        <span className="text-body-small">
                            {externalTicketingProviderLabelText}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};
